import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { fromEntries } from './utils/from-entries/from-entries.js';
import { useCss } from './use-css.js';
import { useMantineTheme, useMantineProviderStyles } from '../theme/MantineProvider.js';
import { mergeClassNames } from './utils/merge-class-names/merge-class-names.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
function createRef(refName) {
  return "__mantine-ref-".concat(refName || "");
}
function getStyles(styles, theme, params) {
  var extractStyles = function extractStyles(stylesPartial) {
    return typeof stylesPartial === "function" ? stylesPartial(theme, params || {}) : stylesPartial || {};
  };
  if (Array.isArray(styles)) {
    return styles.map(function (item) {
      return extractStyles(item.styles);
    }).reduce(function (acc, item) {
      Object.keys(item).forEach(function (key) {
        if (!acc[key]) {
          acc[key] = __spreadValues({}, item[key]);
        } else {
          acc[key] = __spreadValues(__spreadValues({}, acc[key]), item[key]);
        }
      });
      return acc;
    }, {});
  }
  return extractStyles(styles);
}
function createStyles(input) {
  var getCssObject = typeof input === "function" ? input : function () {
    return input;
  };
  function useStyles(params, options) {
    var theme = useMantineTheme();
    var context = useMantineProviderStyles(options == null ? void 0 : options.name);
    var _useCss = useCss(),
      css = _useCss.css,
      cx = _useCss.cx;
    var cssObject = getCssObject(theme, params, createRef);
    var componentStyles = getStyles(options == null ? void 0 : options.styles, theme, params);
    var providerStyles = getStyles(context, theme, params);
    var classes = fromEntries(Object.keys(cssObject).map(function (key) {
      var mergedStyles = cx(_defineProperty({}, css(cssObject[key]), !(options == null ? void 0 : options.unstyled)), css(providerStyles[key]), css(componentStyles[key]));
      return [key, mergedStyles];
    }));
    return {
      classes: mergeClassNames({
        cx: cx,
        classes: classes,
        context: context,
        classNames: options == null ? void 0 : options.classNames,
        name: options == null ? void 0 : options.name
      }),
      cx: cx,
      theme: theme
    };
  }
  return useStyles;
}
export { createStyles };